/**
 * The child routes of /employees/teams/:teamId, generated from the
 * registry: an index redirect to the default page, then one route per
 * entry. App.tsx and the layout test render this same list, so a new page
 * reaches both without a route-table edit.
 */

import { Navigate, Route } from 'react-router-dom'

import { DEFAULT_TEAM_CONFIG_SECTION, TEAM_CONFIG_SECTIONS } from './sections'
import { TeamConfigSectionRoute } from './TeamConfigLayout'

export function teamConfigSectionRoutes(): React.JSX.Element[] {
  return [
    <Route
      key="index"
      index
      element={<Navigate to={DEFAULT_TEAM_CONFIG_SECTION.path} replace />}
    />,
    ...TEAM_CONFIG_SECTIONS.map((section) => (
      <Route
        key={section.path}
        path={section.path}
        element={<TeamConfigSectionRoute section={section} />}
      />
    )),
  ]
}
